import { useState, useEffect } from 'react';
import { useAuth } from '../firebase/useAuth';

interface MarketSummary {
  summary: string;
  timestamp: string;
}

export function useMarketSummary() {
  const { user } = useAuth();
  const [data, setData] = useState<MarketSummary | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }
    const fetchSummary = async () => {
      try {
        const token = await user.getIdToken();
        const res = await fetch(`${import.meta.env.VITE_API_URL}/api/ai/analysis/market-summary`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
          setLoading(false);
          return;
        }
        const json = await res.json();
        if (json.success) setData(json.data);
      } catch {
        // silent fail, widget shows empty state
      } finally {
        setLoading(false);
      }
    };
    fetchSummary();
  }, [user]);

  return { data, loading };
}
